<!-- Header -->
<div class="flex items-center justify-between px-4 pt-4 pb-3">
    <h3 class="text-base font-semibold text-gray-900">Notification</h3>
    <button
        (click)="markAllAsRead()"
        class="text-sm text-gray-500 border border-gray-200 rounded-lg px-3 py-1.5 hover:bg-gray-50"
    >
        Mark all as read
    </button>
</div>

<!-- Tabs -->
<div class="flex gap-1 px-4 border-b border-gray-100">
    @for (tab of tabs; track tab.key) {
        <button
            (click)="_activeTab.set(tab.key); $event.stopPropagation()"
            class="flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-colors relative"
            [class.text-gray-900]="_activeTab() === tab.key"
            [class.text-gray-400]="_activeTab() !== tab.key"
        >
            {{ tab.label }}
            @if (tab.count) {
                <span class="bg-green-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
              {{ tab.count }}
            </span>
            }
            @if (activeTab === tab.key) {
                <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-gray-900 rounded-full"></span>
            }
        </button>
    }
</div>
@for (item of items(); track $index) {
    <div class="flex items-start gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer">
        <!-- Avatar -->
        <div class="relative flex-shrink-0">
            <img [src]="item.avatar" [alt]="item.label" class="w-10 h-10 rounded-full object-cover" />
            @if (!item.read) {
                <span
                    class="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"></span>
            }
        </div>

        <!-- Content -->
        <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-gray-900">{{ item.label }}</p>
            <p class="text-xs text-gray-500 truncate mt-0.5">{{ item.subtitle }}</p>
            <p class="text-xs text-gray-400 mt-1">{{ item.time }}</p>
        </div>

        <!-- Unread dot -->
        @if (!item.read) {
            <span class="w-2 h-2 bg-green-500 rounded-full flex-shrink-0 mt-1.5"></span>
        }
    </div>
}


